import React, {useState} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {v4 as uuid} from 'uuid';

// core components
import IndexNavbar from "components/Navbars/IndexNavbar";
import {useIsBusy} from "hooks/useBusy";
import {APIRequest} from "utils/ApiRequest";
import {toast} from 'react-toastify';

function ChangePasswordPage() {
  const [searchParams] = useSearchParams();
  const history = useNavigate();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [oldPasswd, setOldPasswd] = useState(searchParams.get("code") || "");
  const [password, setPassword] = useState("");
  const prefilled = Boolean(searchParams.get("code"));
  const busy = useIsBusy();

  React.useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        history("/index");
      }
    }

    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  // Initial state only applies on mount, so re-sync if the link params change while mounted.
  React.useEffect(() => {
    const codeParam = searchParams.get("code");
    const emailParam = searchParams.get("email");
    if (codeParam) setOldPasswd(codeParam);
    if (emailParam) setEmail(emailParam);
  }, [searchParams]);

  const handleOldPassWordChange = (e) => {
    setOldPasswd(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value.trim());
  };

  function handleChangePasswordSubmit() {
    if (busy) {
      return;
    }
    if (!email || !oldPasswd || !password) {
      toast.error('All fields are Mandatory!');
    }
    else if (!isValidEmail(email)) {
      toast.error('Email is invalid!');
    } else {
      let iid = uuid();
      APIRequest(
        null,
        "/changePasswd",
        {
          email, tempPasswd: oldPasswd, newPasswd: password
        },
        (res) => {
          toast.success("Your password updated successfully, Please login now!");
          history("/login");
        },
        null,
        { busy: "Updating your password…" }
      );
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleChangePasswordSubmit();
    }
  };

  return (
    <>
      <IndexNavbar />
      <div className="hm-auth">
        <div className="hm-auth-card">
          <img
            className="hm-auth-logo"
            src={require("assets/img/now-logo.png")}
            alt="SORRBA"
          />
          <h1 className="hm-auth-title">Change password</h1>
          <p className="hm-auth-sub">
            {prefilled
              ? "We filled in the code from your email — just choose a new password"
              : "Enter the code from your email and a new password"}
          </p>

          <label className="hm-auth-label" htmlFor="hm-email">
            Email
          </label>
          <input
            id="hm-email"
            className="hm-auth-input"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={handleEmailChange}
          />

          <label className="hm-auth-label" htmlFor="hm-code">
            Temporary code / old password
          </label>
          <input
            id="hm-code"
            className="hm-auth-input"
            type="password"
            placeholder="Enter the code sent to your email"
            value={oldPasswd}
            onChange={handleOldPassWordChange}
          />

          <label className="hm-auth-label" htmlFor="hm-newpass">
            New password
          </label>
          <input
            id="hm-newpass"
            className="hm-auth-input"
            type="password"
            placeholder="Choose a new password"
            value={password}
            onChange={handlePasswordChange}
            onKeyDown={handleKeyDown}
          />

          <button className="hm-auth-btn" onClick={handleChangePasswordSubmit} disabled={busy}>
            {busy ? "Updating…" : "Change password"}
          </button>

          <div className="hm-auth-links hm-auth-links-center">
            <Link to="/login">Back to login</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePasswordPage;
